import React from 'react';
import CompanyInformationDetails from 'src/features/siva/ideas-and-companies/company-details/components/CompanyInformationDetails';
import CompanyBaseInfoBox from 'src/features/siva/ideas-and-companies/components/company/CompanyBaseInfoBox';
import { useExternalCompany } from 'src/hooks/use-external-company';
import useOneWayIn from '../../hooks/use-one-way-in';
import { PageParams } from '../types/PageParams';
import { useParams } from 'react-router-dom';
import useOrgInfo from '../hooks/use-org-info';
import { Link } from '@innovationnorway/cl-react';
import { useAuth } from 'src/features/authorization';
import { useTranslation } from 'react-i18next';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';

const CompanyInfo = () => {
  const { formId } = useParams<PageParams>();
  const { oneWayInOpportunityById } = useOneWayIn(formId);
  const { data: company } = useExternalCompany(oneWayInOpportunityById.data?.organizationNumber ?? '');
  const { isLoading } = useAuth();
  const { t: tOneWayIn } = useTranslation('oneWayIn');
  const { organizationNumber } = useOrgInfo(formId || '');

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <>
      <CompanyBaseInfoBox company={company} />
      <Link
        href={`/resource-base/members/${oneWayInOpportunityById.data?.clusterMemberId}`}
        className="display--block margin-bottom--3 padding-left--2"
      >
        {tOneWayIn('companyInfo.viewInCustomerRegistry')}
      </Link>
      <CompanyInformationDetails
        clusterMemberId={oneWayInOpportunityById.data?.clusterMemberId ?? ''}
        organizationNumber={organizationNumber ?? ''}
        hideNaceWarning
      />
    </>
  );
};

export default CompanyInfo;
